module.exports = __webpack_public_path__ + "img/steel-img-1.6699d6f8.png";